<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      centered
      no-fade
      no-stacking
      title="Hardware Settings"
      ref="posHardwareSettings"
      id="posHardwareSettings"
      size="sm"
      @show="fetchHardwareDetails"
    >
      <div v-if="loading" class="row settings-box">
        <div class="col-12 py-2">
          <div class="row hardwareLoader">
            <div>
              <b-spinner
                label="Processing..."
                class="translate-spinner"
              ></b-spinner>
            </div>
          </div>
        </div>
      </div>
      <div class="row settings-box" v-else-if="DeviceUniqueCode && !loading">
        <div class="col-12 py-2" v-if="false">
          <div class="row">
            <!-- <div class="col-12 d-flex align-items-center fs-11">Hardware Cinema:</div> -->
            <div class="col-12 mb-2">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="HardwareSettings.selectedCinema ? 'shift-up' : ''"
                    >{{ "Cinema" }}</label
                  >
                  <multiselect
                    :options="[...cinemaObj]"
                    v-model="HardwareSettings.selectedCinema"
                    :searchable="true"
                    label="cine_name"
                    track-by="cine_id"
                    placeholder="."
                    :disabled="true"
                    :preselect-first="HardwareSettings.selectedCinema"
                    @select="onSelectHardwareCinema($event, 'select')"
                    @remove="onSelectHardwareCinema($event, 'remove')"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <!-- <div class="col-12 d-flex align-items-center fs-11">POS Location:</div> -->
            <div class="col-12 mb-2">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="HardwareSettings.selectedCinema ? 'shift-up' : ''"
                    >{{ "Cinema" }}</label
                  >
                  <multiselect
                    :options="[...cinemaObj]"
                    v-model="HardwareSettings.selectedCinema"
                    :searchable="true"
                    label="cine_name"
                    track-by="cine_id"
                    placeholder="."
                    :disabled="true"
                    :preselect-first="HardwareSettings.selectedCinema"
                    @select="onSelectHardwareCinema($event, 'select')"
                    @remove="onSelectHardwareCinema($event, 'remove')"
                  ></multiselect>
                </div>
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="HardwareSettings.hs_hardware_name"
                    id="hs_hardware_name"
                    name="hs_hardware_name"
                    type="text"
                  />
                   <label
                    :class="HardwareSettings.hs_hardware_name ? 'shift-up' : ''"
                    >{{ "Name" }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="HardwareSettings.selectedLocation ? 'shift-up' : ''"
                    >{{ "POS Location" }}</label
                  >
                  <multiselect
                    :options="HardwareLocations"
                    v-model="HardwareSettings.selectedLocation"
                    :searchable="true"
                    label="location_name"
                    track-by="hl_id"
                    placeholder="."
                    @select="onSelectHardwareLocation($event, 'select')"
                    @remove="onSelectHardwareLocation($event, 'remove')"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex align-items-center w-100 justify-content-center my-5"
        v-else
      >
        <div>Device ID Not Found</div>
      </div>

      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button v-on:click="saveSettings()" class="btn-blue">Save</button>
          <button
            @click.prevent.stop="$bvModal.hide('posHardwareSettings')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index.js";
import MasterService from "@/services/MasterService";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { backendSocket, EventBus } from "@/main.js";

export default {
  props: {},
  components: {
    Vkeyboard,
    VkeyboardFloat,
  },
  data() {
    return {
      cinemaObj: {
        cine_id: this.getCinemaId(),
        cine_name: this.getUserDetail("cine_name"),
      },
      HardwareLocations: [],
      HardwareSettings: {
        selectedLocation: "",
        hardware_location_id: null,
        hs_hardware_name: null,
        cinema_id: null,
        selectedCinema: "",
      },
      loading: false,
      DeviceUniqueCode: null,
      hardware_id: null,
      keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
    };
  },
  sockets: {
    hardwareId: function (macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    },
  },
  // watch: {
  //   loading: function (newValue) {
  //     console.log('watch loading', newValue);
  //     if (newValue) {
  //       this.showLoading();
  //     } else {
  //       this.hideLoading();
  //     }
  //   },
  // },
  computed: {},
  beforeMount() {
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
  },
  mounted() {},
  methods: {
    async fetchHardwareDetails() {
      this.loading = true;
      MasterService.getPosHardwareSettings({
        unique_id: this.DeviceUniqueCode,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            Object.keys(this.HardwareSettings).map((key) => {
              this.HardwareSettings[key] =
                data.Records[0][key] || this.HardwareSettings[key];
            });
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          MasterService.getHardwarelocationByCinema({
            cinema_id: this.cinemaObj.cine_id,
          })
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.HardwareLocations = data.Records;
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },
    getHardwareDetails() {
      let hardwareObj = {
        selectedLocation: "",
        hardware_location_id: null,
        hs_hardware_name: "",
        cinema_id: null,
        selectedCinema: "",
      };
      return new Promise(async (resolve) => {
        MasterService.getPosHardwareSettings({
          unique_id: this.DeviceUniqueCode,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              Object.keys(hardwareObj).map((key) => {
                hardwareObj[key] = data.Records[0][key] || hardwareObj[key];
              });
            }
            resolve(hardwareObj);
          })
          .catch((err) => {
            console.log("Error:", err);
            resolve(hardwareObj);
          });
      });
    },
    getHardwareLocation() {
      return new Promise(async (resolve) => {
        let locations = [];
        MasterService.getHardwarelocationByCinema({
          cinema_id: this.cinemaObj.cine_id,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              locations = data.Records;
            }
            resolve(locations || []);
          })
          .catch((err) => {
            console.log("Error:", err);
            resolve(locations || []);
          });
      });
    },
    onSelectHardwareLocation(event, type = "select") {
      if (type == "select") {
        this.HardwareSettings.selectedLocation = event;
        this.HardwareSettings.hardware_location_id = event.hl_id;
      } else if (type == "remove") {
        this.HardwareSettings.selectedLocation = "";
        this.HardwareSettings.hardware_location_id = null;
      }
    },
    onSelectHardwareCinema(event, type = "select") {
      if (type == "select") {
        this.HardwareSettings.selectedCinema = event;
        this.HardwareSettings.cinema_id = event.cine_id;
      } else if (type == "remove") {
        this.HardwareSettings.selectedCinema = "";
        this.HardwareSettings.cinema_id = null;
      }
    },
    saveSettings() {
      this.showLoading();
      let hardwareObj = {
        hardware_location_id: this.HardwareSettings.hardware_location_id,
        hs_hardware_name: this.HardwareSettings.hs_hardware_name,
        cinema_id: this.HardwareSettings.cinema_id,
        unique_id: this.DeviceUniqueCode,
      };
      MasterService.UpdatePosHardwareSettings(hardwareObj)
        .then((response) => {
          const { data } = response;
          console.log("DATA", data);
          if (data && data.status) {
            if (this.DeviceUniqueCode) {
              this.$store.dispatch(
                "fetchPosHardwareSettings",
                this.DeviceUniqueCode
              );
            }
            console.log("SUCCESSFULLY SAVED HARDWARE LOCATION");
          } else {
            console.log("UNABLE TO SAVE HARDWARE LOCATION");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.$bvModal.hide("posHardwareSettings");
          this.hideLoading();
        });
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.settings-box {
  font-size: 12px;
  font-weight: bold;
}
#posHardwareSettings___BV_modal_content_ {
  width: 135% !important;
  max-width: 135% !important;
  min-width: 135% !important;
  margin: auto;
  zoom: 0.8;
}

.hardwareLoader {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosHardwareSettingsPopup.vue